interface RatingBadgeProps {
  rating: number;
  level: 'highest' | 'high' | 'medium';
}

export default function RatingBadge({ rating, level }: RatingBadgeProps) {
  const bg =
    level === 'highest'
      ? 'bg-accent-500'
      : level === 'high'
        ? 'bg-primary-500'
        : 'bg-secondary-500';
  return (
    <span
      className={`flex items-center gap-1 rounded-full ${bg} px-2 py-0.5 text-xs font-semibold text-background-50 dark:text-foreground-950`}
      title="评分为虚构演示数据"
    >
      {rating.toFixed(1)}
    </span>
  );
}